export default {
    install(Vue, options) {
        Vue.mixin({
            data() {
                return { 
                    sharedState: options.store.state
                }
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/framework/storePlugin.js